package app.nestbridge.domain.identity.service

import app.nestbridge.domain.identity.api.UserProfileApiClient
import app.nestbridge.domain.identity.model.UserProfile
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class, boundType = UserProfileService::class)
@Inject
class DefaultUserProfileService(
    private val apiClient: UserProfileApiClient,
) : UserProfileService {

    override suspend fun getCurrent(): UserProfile? = apiClient.fetchCurrent()?.toDomain()

    override suspend fun save(profile: UserProfile): UserProfile = apiClient.save(profile.toDto()).toDomain()
}
